var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"miniliink",class:['miniliink', { inApp: _vm.$root.$data.isApp || this.$root.miniprogram }]},[_c('div',{staticClass:"miniliink-box"},[_c('img',{staticClass:"pxind",attrs:{"src":"https://iqh-zt-pord-cdn.iqihang.com/25season/mzt/minilink.jpeg","alt":""}}),_c('button',{on:{"click":_vm.gostudy}},[_vm._v("前往小程序")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }